import { Q } from '@nozbe/watermelondb'
import {
  ChatSessionState,
  ChatSource,
  ComponentDestinationVO,
  ComponentInfoLoadChatsVO,
  ComponentPeriodVO
} from '@repo/types'
import { normalize } from './utils'

export const getChatListFiltersPredicate = (filters: ComponentInfoLoadChatsVO) => {
  const wheresFiltered = [
    getOnlyArchivedsWhere(filters.onlyArchiveds, filters.globalSearch),
    getOnlyUnreadsWhere(filters.onlyUnreads),
    getOnlyWithoutFirstContactWhere(filters.onlyWithoutFirstContact),
    getOnlyWithoutDestinationWhere(filters.onlyWithoutDestination),
    getPeriodWhere(filters.period),
    getGlobalSearchWhere(filters.globalSearch),
    getOnlyNotClients(filters.onlyNotClients),
    getOnlyMyMessages(filters.onlyMyMessages, filters.userId),
    getDestinations(filters.destinations),
    getOnlyWithoutAnswer(filters.onlyWithoutAnswer),
    getOnlyAiSessions(filters.onlyAiSessions)
  ].filter(it => it !== undefined) as Q.Where[]

  return Q.and(wheresFiltered)
}

const getOnlyArchivedsWhere = (onlyArchiveds: boolean, globalSearch: string) => {
  return globalSearch.length > 0 ? undefined : Q.where('is_archived', onlyArchiveds)
}

const getOnlyUnreadsWhere = (onlyUnreads: boolean) => {
  return onlyUnreads ? Q.where('unreads', Q.gt(0)) : undefined
}

const getOnlyWithoutFirstContactWhere = (onlyWithoutFirstContact: boolean) => {
  return onlyWithoutFirstContact ? Q.where('first_contact_at', Q.eq(null)) : undefined
}

const getPeriodWhere = (period?: ComponentPeriodVO) => {
  if (period?.start && period.end) {
    const startDateTime = new Date(period.start).setHours(0, 0, 0)
    const endDateTime = new Date(period.end).setHours(23, 59, 59)
    return Q.where('contact_at', Q.between(startDateTime, endDateTime))
  } else {
    return undefined
  }
}

const getOnlyWithoutDestinationWhere = (onlyWithoutDestination: boolean) => {
  return onlyWithoutDestination
    ? Q.where('session_state', Q.eq(ChatSessionState.WAIT_MENU_ANSWER))
    : Q.where('session_state', Q.notEq(ChatSessionState.WAIT_MENU_ANSWER))
}

const getGlobalSearchWhere = (globalSearch: string) => {
  const normalizedGlobalSearch = normalize(globalSearch)
  const qLike = `%${Q.sanitizeLikeString(normalizedGlobalSearch)}%`
  return normalizedGlobalSearch !== '' ? Q.where('normalized_search', Q.like(qLike)) : undefined
}

const getOnlyNotClients = (onlyNotClients: boolean) => {
  return onlyNotClients ? Q.where('client_code', Q.eq(null)) : undefined
}

const getOnlyAiSessions = (onlyAiSessions: boolean) => {
  return onlyAiSessions ? Q.where('is_ai_session', onlyAiSessions) : undefined
}

const getOnlyMyMessages = (onlyMyMessages: boolean, userId?: string) => {
  return onlyMyMessages && userId ? Q.where('user_id', Q.eq(userId)) : undefined
}

const getDestinations = (destinations: ComponentDestinationVO[]) => {
  const descriptions = destinations.map(it => it.destinationDescription.trim())

  return descriptions.length > 0
    ? Q.or(
        Q.where('destination_description', Q.oneOf(descriptions)),
        Q.where('destination_description', Q.like('%wingo%'))
      )
    : undefined
}

const getOnlyWithoutAnswer = (onlyWithoutAnswer: boolean) => {
  return onlyWithoutAnswer ? Q.where('last_message_source', Q.eq(ChatSource.CLIENT)) : undefined
}
